import useToggle from '../../../hooks/useToggle';
import Modal from '../../Common/Modal';
import Payment from '../Payment/Payment';
import { useFlutterwavePayment } from '../../../hooks/payment/useFlutterwave';
import { RootState } from '../../../states/reducers';
import { useSelector } from 'react-redux';
import { closePaymentModal } from 'flutterwave-react-v3';
import { useDisburseLoan } from '../../../hooks/payment/useDisburseLoan';
import PaymentSummary from '../Payment/PaymentSummary';
import LoadingIndicator from '../../Common/LoadingIndicator';
import ErrorNotification from '../../Common/ErrorNotification';
import SuccessNotification from '../../Common/SuccessNotification';

const DisburseLoan = () => {
  const { show: showForm, toggle: toggleForm } = useToggle();
  const { loan } = useSelector((state: RootState) => state.loan);
  const { handleFlutterPayment } = useFlutterwavePayment(parseFloat(loan!.amount), 'Loan Disbursement', 'Loan Disbursement');
  const { processing, error, success, handleVerifyDisbursement, handleCardDisbursement, handleWalletDisbursement } = useDisburseLoan();

  const onNewCardHandler = () => {
    handleFlutterPayment({
      callback: (response) => {
        console.log(response);
        closePaymentModal();
        handleVerifyDisbursement({ loan_id: loan!.id, transaction_id: response.transaction_id });
      },
      onClose: () => {},
    });
  };

  const onSavedCardHandler = (cardId: number) => {
    handleCardDisbursement({
      loan_id: loan!.id,
      card_id: cardId,
    });
  };

  const onWalletHandler = () => {
    handleWalletDisbursement({ loan_id: loan!.id });
  };

  return (
    <>
      <button className='btn btn-sm btn-primary me-3 my-5' onClick={toggleForm}>
        Disburse Loan
      </button>

      <Modal show={showForm} toggle={toggleForm} backDropClose={false} title='Disburse Loan'>
        {processing ? (
          <div className='text-center'>
            <LoadingIndicator />
          </div>
        ) : error ? (
          <ErrorNotification message={error} />
        ) : success ? (
          <SuccessNotification message='Your loan has been disbursed' />
        ) : (
          <>
            <PaymentSummary amount={parseFloat(loan!.amount)} />
            <Payment newCardHandler={onNewCardHandler} savedCardHandler={onSavedCardHandler} walletHandler={onWalletHandler} />
          </>
        )}
      </Modal>
    </>
  );
};

export default DisburseLoan;
